import { isAwaitingLandlordSend } from '../../../utils/transactionDisplay';

export type TransactionStatus =
  | 'success'
  | 'failed'
  | 'pending'
  | 'refund'
  | 'processedAsInternalPayment'
  | 'queueForPayment'
  | 'underProcessingForPayment';

export interface StatusConfig {
  label: string;
  colorClass: string;
  bgColorClass: string;
}

export const getStatusConfig = (
  status: string,
  expectedPaymentSendDate?: string | null
): StatusConfig => {
  if (isAwaitingLandlordSend(status, expectedPaymentSendDate)) {
    return {
      label: 'Processing',
      colorClass: 'text-[#F59E0B]',
      bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
    };
  }
  switch (status) {
    case 'success':
      return {
        label: 'Completed',
        colorClass: 'text-success',
        bgColorClass: 'bg-[rgba(8,155,25,0.10)]',
      };
    case 'failed':
      return {
        label: 'Failed',
        colorClass: 'text-failure',
        bgColorClass: 'bg-[rgba(183,13,13,0.08)]',
      };
    case 'pending':
      return {
        label: 'Pending',
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
    case 'refund':
      return {
        label: 'Refunded',
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
    case 'processedAsInternalPayment':
      return {
        label: 'Processed as Internal Payment',
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
    case 'queueForPayment':
      return {
        label: 'In Processing',
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
    case 'underProcessingForPayment':
      return {
        label: 'In Processing',
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
    default:
      return {
        label: status.charAt(0).toUpperCase() + status.slice(1),
        colorClass: 'text-[#F59E0B]',
        bgColorClass: 'bg-[rgba(245,158,11,0.10)]',
      };
  }
};

export const getStatusColor = (status: string): string => {
  if (status === 'success') {
    return 'text-success';
  } else if (status === 'failed') {
    return 'text-failure';
  } else {
    return 'text-[#F59E0B]';
  }
};

